function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

import { getIdentifierHeaders } from '@zuldigital/utils';
import axios from 'axios';
import * as threeds2utilities from './lib/threeds2utilities';
import { getThreeDSCompInd } from './lib/get-3ds-comp-ind';
import { getChallengeIframe } from './lib/get-challenge-iframe';
import { Pubsub } from './lib/pubsub';
import { OrderStatuses, PaymentCategories, OrderCategories } from './lib/statuses';
export var Events = {
  CLOSE_MODAL: 'close-modal',
  OPEN_MODAL: 'open-modal',
  START_LOADING: 'start-loading',
  FINISH_LOADING: 'finish-loading',
  LOCK_SCROLL: 'lock-scroll',
  UNLOCK_SCROLL: 'unlock-scroll',
  CANCEL_ORDER: 'cancel-order',
  EMPTY_AUTH: 'empty-auth'
};

var _promiseResolveRef = /*#__PURE__*/_classPrivateFieldLooseKey("promiseResolveRef");

var _promiseRejectedRef = /*#__PURE__*/_classPrivateFieldLooseKey("promiseRejectedRef");

var _authHasAlreadyCanceledRef = /*#__PURE__*/_classPrivateFieldLooseKey("authHasAlreadyCanceledRef");

var _observable = /*#__PURE__*/_classPrivateFieldLooseKey("observable");

var _iframeContainer = /*#__PURE__*/_classPrivateFieldLooseKey("iframeContainer");

var _api = /*#__PURE__*/_classPrivateFieldLooseKey("api");

var _generateFingerprintIframeContainer = /*#__PURE__*/_classPrivateFieldLooseKey("generateFingerprintIframeContainer");

var _getFingerprintAuthorization = /*#__PURE__*/_classPrivateFieldLooseKey("getFingerprintAuthorization");

var _getChallengeAuthorization = /*#__PURE__*/_classPrivateFieldLooseKey("getChallengeAuthorization");

var _confirmFingerprint = /*#__PURE__*/_classPrivateFieldLooseKey("confirmFingerprint");

var _cancelOrder = /*#__PURE__*/_classPrivateFieldLooseKey("cancelOrder");

var _challengeConfirmation = /*#__PURE__*/_classPrivateFieldLooseKey("challengeConfirmation");

var _getFingerprintResult = /*#__PURE__*/_classPrivateFieldLooseKey("getFingerprintResult");

var _handleConfirmationError = /*#__PURE__*/_classPrivateFieldLooseKey("handleConfirmationError");

var _startChallenge = /*#__PURE__*/_classPrivateFieldLooseKey("startChallenge");

var _handleFingerprint = /*#__PURE__*/_classPrivateFieldLooseKey("handleFingerprint");

var _handleChallenge = /*#__PURE__*/_classPrivateFieldLooseKey("handleChallenge");

var _errorHandling = /*#__PURE__*/_classPrivateFieldLooseKey("errorHandling");

export class ThreeDsAuth {
  constructor(_ref, api) {
    var {
      orderId,
      category,
      status,
      URL,
      FINGERPRINT_POST_BACK_URL,
      getChallengeIframeContainer
    } = _ref;
    Object.defineProperty(this, _errorHandling, {
      value: _errorHandling2
    });
    Object.defineProperty(this, _handleChallenge, {
      value: _handleChallenge2
    });
    Object.defineProperty(this, _handleFingerprint, {
      value: _handleFingerprint2
    });
    Object.defineProperty(this, _startChallenge, {
      value: _startChallenge2
    });
    Object.defineProperty(this, _handleConfirmationError, {
      value: _handleConfirmationError2
    });
    Object.defineProperty(this, _getFingerprintResult, {
      value: _getFingerprintResult2
    });
    Object.defineProperty(this, _challengeConfirmation, {
      value: _challengeConfirmation2
    });
    Object.defineProperty(this, _cancelOrder, {
      value: _cancelOrder2
    });
    Object.defineProperty(this, _confirmFingerprint, {
      value: _confirmFingerprint2
    });
    Object.defineProperty(this, _getChallengeAuthorization, {
      value: _getChallengeAuthorization2
    });
    Object.defineProperty(this, _getFingerprintAuthorization, {
      value: _getFingerprintAuthorization2
    });
    Object.defineProperty(this, _generateFingerprintIframeContainer, {
      value: _generateFingerprintIframeContainer2
    });
    Object.defineProperty(this, _promiseResolveRef, {
      writable: true,
      value: () => {}
    });
    Object.defineProperty(this, _promiseRejectedRef, {
      writable: true,
      value: () => {}
    });
    this.categoryRef = '';
    this.orderIdRef = 0;
    this.statusRef = '';
    this.FINGERPRINT_POST_BACK_URL = '';
    this.URL = '';
    Object.defineProperty(this, _authHasAlreadyCanceledRef, {
      writable: true,
      value: false
    });
    this.challengeIframeContainerRef = null;
    this.getChallengeIframeContainer = void 0;
    Object.defineProperty(this, _observable, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _iframeContainer, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _api, {
      writable: true,
      value: axios
    });
    this.categoryRef = category;
    this.orderIdRef = orderId;
    this.statusRef = status;

    _classPrivateFieldLooseBase(this, _generateFingerprintIframeContainer)[_generateFingerprintIframeContainer]();

    this.FINGERPRINT_POST_BACK_URL = FINGERPRINT_POST_BACK_URL;
    this.URL = URL;
    _classPrivateFieldLooseBase(this, _observable)[_observable] = new Pubsub();
    this.getChallengeIframeContainer = getChallengeIframeContainer;

    if (api) {
      _classPrivateFieldLooseBase(this, _api)[_api] = api;
    }
  }

  on(event, listener) {
    _classPrivateFieldLooseBase(this, _observable)[_observable].on(event, listener);

    return this;
  }

  cancelPaymentAuthentication() {
    var cancel3dsForm = new FormData();
    cancel3dsForm.append('forced', 'true');
    return _classPrivateFieldLooseBase(this, _api)[_api].post(this.URL + "/payment/3ds/" + this.orderIdRef + "/" + PaymentCategories[this.categoryRef.toUpperCase()] + "/cancel", cancel3dsForm, {
      headers: _extends({
        'X-Origin': 'WEB_APP'
      }, getIdentifierHeaders())
    });
  }

  start() {
    var _this = this;

    _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.START_LOADING);

    return new Promise( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (resolve, reject) {
        _classPrivateFieldLooseBase(_this, _promiseResolveRef)[_promiseResolveRef] = resolve;
        _classPrivateFieldLooseBase(_this, _promiseRejectedRef)[_promiseRejectedRef] = reject;

        if (_this.statusRef === OrderStatuses.AUTH_CHALLENGE) {
          _classPrivateFieldLooseBase(_this, _handleChallenge)[_handleChallenge]();
        } else if (_this.statusRef === OrderStatuses.AUTH_FINGERPRINT) {
          _classPrivateFieldLooseBase(_this, _handleFingerprint)[_handleFingerprint]();
        }
      });

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  }

}

function _generateFingerprintIframeContainer2() {
  if (!document.querySelector('#container-3ds')) {
    var div = document.createElement('div');
    div.setAttribute('id', 'container-3ds');
    document.body.appendChild(div);
    _classPrivateFieldLooseBase(this, _iframeContainer)[_iframeContainer] = document.querySelector('#container-3ds');
  } else if (!_classPrivateFieldLooseBase(this, _iframeContainer)[_iframeContainer]) {
    _classPrivateFieldLooseBase(this, _iframeContainer)[_iframeContainer] = document.querySelector('#container-3ds');
  }
}

function _getFingerprintAuthorization2() {
  return _classPrivateFieldLooseBase(this, _api)[_api].get(this.URL + "/payment/3ds/" + this.orderIdRef + "/" + PaymentCategories[this.categoryRef] + "/fingerprint", {
    headers: _extends({
      'X-Origin': 'WEB_APP'
    }, getIdentifierHeaders())
  });
}

function _getChallengeAuthorization2() {
  return _classPrivateFieldLooseBase(this, _api)[_api].get(this.URL + "/payment/3ds/" + this.orderIdRef + "/" + PaymentCategories[this.categoryRef.toUpperCase()] + "/challenge", {
    headers: _extends({
      'X-Origin': 'WEB_APP'
    }, getIdentifierHeaders())
  });
}

function _confirmFingerprint2(threeDSCompInd) {
  return new Promise((resolve, reject) => {
    _classPrivateFieldLooseBase(this, _api)[_api].post(this.URL + "/payment/3ds/" + this.orderIdRef + "/" + PaymentCategories[this.categoryRef.toUpperCase()] + "/fingerprint", {
      threeDSCompInd
    }, {
      headers: _extends({
        'X-Origin': 'WEB_APP'
      }, getIdentifierHeaders())
    }).then(response => resolve(response)).catch(error => reject(error));
  });
}

function _cancelOrder2() {
  _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.CANCEL_ORDER);
}

function _challengeConfirmation2(transStatus) {
  var challengeForm = new FormData();
  challengeForm.append('transStatus', transStatus);
  return _classPrivateFieldLooseBase(this, _api)[_api].post(this.URL + "/payment/3ds/" + this.orderIdRef + "/" + PaymentCategories[this.categoryRef.toUpperCase()] + "/challenge", challengeForm, {
    headers: _extends({
      'X-Origin': 'WEB_APP'
    }, getIdentifierHeaders())
  });
}

function _getFingerprintResult2(serverTransactionID, methodURL, iframeContainer) {
  return getThreeDSCompInd({
    threedsMethodNotificationURL: this.FINGERPRINT_POST_BACK_URL,
    methodURL,
    serverTransactionID,
    API: this.URL
  }, iframeContainer);
}

function _handleConfirmationError2(error) {
  if ('response' in error) {
    var _response$data;

    var axiosError = error;
    var response = axiosError == null ? void 0 : axiosError.response;
    var responseData = response == null ? void 0 : (_response$data = response.data) == null ? void 0 : _response$data.data;

    if (response.status === 426) {
      var {
        threeDSServerTransID,
        acsTransID,
        messageVersion,
        acsURL
      } = responseData;

      _classPrivateFieldLooseBase(this, _startChallenge)[_startChallenge]({
        acsURL,
        threeDSServerTransID,
        acsTransID,
        messageVersion
      });
    } else {
      _classPrivateFieldLooseBase(this, _promiseRejectedRef)[_promiseRejectedRef](error);

      _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.CLOSE_MODAL);
    }
  } else {
    this.cancelPaymentAuthentication().catch(() => {});

    _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.CLOSE_MODAL);

    if (this.categoryRef !== OrderCategories.CARD_VERIFICATION) {
      _classPrivateFieldLooseBase(this, _cancelOrder)[_cancelOrder]();
    }

    _classPrivateFieldLooseBase(this, _promiseRejectedRef)[_promiseRejectedRef]();

    _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.FINISH_LOADING);

    _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.UNLOCK_SCROLL);
  }
}

function _startChallenge2(_x3) {
  return _startChallenge3.apply(this, arguments);
}

function _startChallenge3() {
  _startChallenge3 = _asyncToGenerator(function* (_ref3) {
    var {
      acsURL = '',
      threeDSServerTransID = '',
      acsTransID = '',
      messageVersion = ''
    } = _ref3;

    _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.OPEN_MODAL);

    _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.LOCK_SCROLL);

    try {
      var challengeWindowSize = threeds2utilities.config.validateChallengeWindowSize('04');
      this.challengeIframeContainerRef = yield this.getChallengeIframeContainer();

      if (this.challengeIframeContainerRef) {
        ;
        this.challengeIframeContainerRef.innerHTML = '';
      }

      _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.FINISH_LOADING);

      _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.OPEN_MODAL);

      var createChallengeResponse = yield getChallengeIframe({
        acsURL,
        payload: {
          threeDSServerTransID,
          acsTransID,
          messageVersion,
          messageType: 'CReq',
          challengeWindowSize
        },
        API: this.URL,
        iframeConfig: {
          container: this.challengeIframeContainerRef,
          size: '04'
        }
      });

      _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.START_LOADING);

      _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.UNLOCK_SCROLL);

      if ((createChallengeResponse == null ? void 0 : createChallengeResponse.transStatus) === 'Y') {
        _classPrivateFieldLooseBase(this, _challengeConfirmation)[_challengeConfirmation](createChallengeResponse == null ? void 0 : createChallengeResponse.transStatus).catch(_classPrivateFieldLooseBase(this, _errorHandling)[_errorHandling].bind(this)).finally(() => {
          _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.FINISH_LOADING);

          _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.UNLOCK_SCROLL);

          _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.CLOSE_MODAL);
        }).then(challengeConfirmationResponse => {
          _classPrivateFieldLooseBase(this, _promiseResolveRef)[_promiseResolveRef](challengeConfirmationResponse.data);
        });
      } else if ((createChallengeResponse == null ? void 0 : createChallengeResponse.transStatus) === 'N') {
        yield this.cancelPaymentAuthentication();

        if (this.categoryRef !== OrderCategories.CARD_VERIFICATION) {
          yield _classPrivateFieldLooseBase(this, _cancelOrder)[_cancelOrder]();
        }

        _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.FINISH_LOADING);

        _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.UNLOCK_SCROLL);

        _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.CLOSE_MODAL);

        _classPrivateFieldLooseBase(this, _promiseRejectedRef)[_promiseRejectedRef]('Não foi possível autenticar o cartão.');
      } else {
        _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.START_LOADING);

        _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.CLOSE_MODAL);

        yield this.cancelPaymentAuthentication();

        if (this.categoryRef !== OrderCategories.CARD_VERIFICATION) {
          _classPrivateFieldLooseBase(this, _cancelOrder)[_cancelOrder]();
        }

        _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.FINISH_LOADING);

        _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.UNLOCK_SCROLL);
      }
    } catch (error) {
      _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.FINISH_LOADING);

      _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.UNLOCK_SCROLL);

      _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.CLOSE_MODAL);

      this.cancelPaymentAuthentication().catch(() => {});

      _classPrivateFieldLooseBase(this, _promiseRejectedRef)[_promiseRejectedRef]('Não foi possível concluir autenticação.');
    }
  });
  return _startChallenge3.apply(this, arguments);
}

function _handleFingerprint2() {
  var handleSuccessfulFingerprintAuthorization = response => {
    var {
      data: authorizationData,
      status: responseStatus
    } = response;

    if (responseStatus === 204) {
      _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.FINISH_LOADING);

      this.cancelPaymentAuthentication().finally(() => {
        _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.CLOSE_MODAL);
      });

      if (this.categoryRef !== OrderCategories.CARD_VERIFICATION) {
        _classPrivateFieldLooseBase(this, _cancelOrder)[_cancelOrder]();
      }

      _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.EMPTY_AUTH);

      return;
    }

    if (authorizationData) {
      _classPrivateFieldLooseBase(this, _getFingerprintResult)[_getFingerprintResult](authorizationData.threeDSServerTransID, authorizationData.threeDSMethodURL, _classPrivateFieldLooseBase(this, _iframeContainer)[_iframeContainer]).then(_ref4 => {
        var {
          threeDSCompInd
        } = _ref4;
        return _classPrivateFieldLooseBase(this, _confirmFingerprint)[_confirmFingerprint](threeDSCompInd).then(challengeConfirmationResponse => {
          _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.FINISH_LOADING);

          _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.UNLOCK_SCROLL);

          _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.CLOSE_MODAL);

          _classPrivateFieldLooseBase(this, _promiseResolveRef)[_promiseResolveRef](challengeConfirmationResponse.data);
        }).catch(error => {
          _classPrivateFieldLooseBase(this, _handleConfirmationError)[_handleConfirmationError](error);
        });
      }).catch(error => {
        _classPrivateFieldLooseBase(this, _handleConfirmationError)[_handleConfirmationError](error);
      });
    } else if (!_classPrivateFieldLooseBase(this, _authHasAlreadyCanceledRef)[_authHasAlreadyCanceledRef]) {
      if (this.categoryRef !== OrderCategories.CARD_VERIFICATION) {
        _classPrivateFieldLooseBase(this, _cancelOrder)[_cancelOrder]();
      }

      this.cancelPaymentAuthentication().catch(() => {});
      _classPrivateFieldLooseBase(this, _authHasAlreadyCanceledRef)[_authHasAlreadyCanceledRef] = true;
      this.start();
    }
  };

  _classPrivateFieldLooseBase(this, _getFingerprintAuthorization)[_getFingerprintAuthorization]().then(handleSuccessfulFingerprintAuthorization).catch(_classPrivateFieldLooseBase(this, _errorHandling)[_errorHandling].bind(this));
}

function _handleChallenge2() {
  var handleSuccessfulChallengeAuthorization = response => {
    var {
      data: authorizationData,
      status: responseStatus
    } = response;

    if (responseStatus === 204) {
      this.cancelPaymentAuthentication().catch(() => {});

      if (this.categoryRef !== OrderCategories.CARD_VERIFICATION) {
        _classPrivateFieldLooseBase(this, _cancelOrder)[_cancelOrder]();
      }

      _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.EMPTY_AUTH);

      _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.CLOSE_MODAL);

      _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.UNLOCK_SCROLL);

      _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.FINISH_LOADING);

      return;
    }

    if (authorizationData) {
      var {
        threeDSServerTransID,
        acsTransID,
        messageVersion,
        acsURL
      } = authorizationData;

      _classPrivateFieldLooseBase(this, _startChallenge)[_startChallenge]({
        acsURL,
        threeDSServerTransID,
        acsTransID,
        messageVersion
      });
    }
  };

  _classPrivateFieldLooseBase(this, _getChallengeAuthorization)[_getChallengeAuthorization]().then(handleSuccessfulChallengeAuthorization).catch(_classPrivateFieldLooseBase(this, _errorHandling)[_errorHandling].bind(this));
}

function _errorHandling2(error) {
  _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.CLOSE_MODAL);

  _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.FINISH_LOADING);

  _classPrivateFieldLooseBase(this, _observable)[_observable].publish(Events.UNLOCK_SCROLL);

  _classPrivateFieldLooseBase(this, _promiseRejectedRef)[_promiseRejectedRef](error);
}
//# sourceMappingURL=three-ds-auth.js.map